import React, { useState } from "react";
import Seo, { breadcrumbSchema, privateLabelServiceSchema, webPageSchema } from "../Seo/Seo";
import ContactModal from "../ContactModal/ContactModal";
import solutionImage from "../../Assets/blogs/klean-leaf-laundry-sheet-production-lines.webp";
import { SolutionHero, SolutionPaths, PrivateLabelProcess, BrandCustomization, PackagingShowcase,
  BusinessFacts, WhoWeSupport, BulkRefillSolution, ManufacturingSupport, ExpandedProducts, FinalCTA } from "./PrivateLabelSections";

const pageTitle = "Private Label Laundry Detergent Sheet Solutions | Klean Leaf";
const pageDescription = "Develop private label laundry detergent sheets with custom formula, fragrance and packaging. From samples to manufacturing and shipping, plus bulk and refill supply.";
const solutionServiceSchema = { ...privateLabelServiceSchema, description: pageDescription };

function Solution() {
  const [inquiryType, setInquiryType] = useState(null);
  const showContactModal = () => setInquiryType("private-label");
  return <>
    <Seo title={pageTitle} description={pageDescription} path="/solution"
      image={solutionImage} imageType="image/webp" imageWidth={1280} imageHeight={960}
      imageAlt="Klean Leaf laundry sheet manufacturing lines and rolls of sheet material" schema={[
      solutionServiceSchema,
      webPageSchema({ name: pageTitle, description: pageDescription, path: "/solution", primaryImage: solutionImage }),
      breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Private Label Solutions", path: "/solution" }]),
    ]} />
    <main className="solution-page mobile-type" id="solution">
      <SolutionHero onContact={showContactModal} />
      <SolutionPaths />
      <PrivateLabelProcess />
      <BrandCustomization />
      <PackagingShowcase />
      <BusinessFacts />
      <WhoWeSupport />
      <BulkRefillSolution onContact={() => setInquiryType("bulk")} />
      <ManufacturingSupport />
      <ExpandedProducts />
      <FinalCTA onContact={showContactModal} />
    </main>
    <ContactModal mobileTypography isModalOpen={inquiryType !== null} handleCancel={() => setInquiryType(null)}
      idPrefix="solution-page-contact" title={inquiryType === "bulk" ? "Ask About Bulk Supply" : "Start Your Project"}
      productName={inquiryType === "bulk" ? "Bulk Laundry Detergent Sheets" : "Private Label Laundry Detergent Sheets"} />
  </>;
}
export default Solution;
